var map = {
	"./bath.svg": 8233,
	"./bed-single.svg": 6245,
	"./big-bed.svg": 3443,
	"./closet.svg": 801,
	"./conditioner.svg": 7306,
	"./fridge.svg": 3163,
	"./jacuzzi.svg": 835,
	"./kettle.svg": 4436,
	"./kitchen.svg": 4885,
	"./oven.svg": 2675,
	"./phone.svg": 4519,
	"./radio.svg": 2779,
	"./sauna.svg": 369,
	"./shower.svg": 8784,
	"./sofa.svg": 2265,
	"./tv.svg": 6336,
	"./wifi.svg": 8606,
	"./солнце.svg": 7238,
	"./холодос.svg": 5915
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 514;